"use client";

import styled from "styled-components";

//Components
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "../ui/dropdown-menu";
import Image from "../image";

export const DropdownProfile = styled(DropdownMenu)``;

export const ButtonNotfication = styled(DropdownMenuTrigger)`
  position: relative;
  padding: 8px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 10px;

  svg {
    path {
      transition: all 0.3s easy-out;
      fill: var(--colorTitle);
    }
  }
`;

export const ProfileContent = styled(DropdownMenuContent)`
  width: 180px;
  background: var(--backgroundColorCard);
  margin-top: 8px;
  z-index: 9999;
`;

export const ButtonItemNotfication = styled.button`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  gap: 10px;
  cursor: pointer;

  svg {
    margin-top: 2px;
  }
`;

export const ImageComponent = styled(Image)`
  border-radius: 100px;
  width: 30px;
  height: 30px;
  object-fit: cover;
`;

export const Text = styled.span`
  font-family: "Roboto Light";
  font-size: 14px;
  color: var(--textColor);
`;

export const UserName = styled.span`
  font-family: "Helvetica Neue Medium";
  font-weight: 500;
  font-size: 14px;
  color: var(--colorTitle);
  text-wrap: nowrap;
  display: block;
`;
